export default __webpack_public_path__ + "931b5be4256b4a07513edad841d3762e.svg";